import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import axios from 'axios'
import Fade from '@material-ui/core/Fade'
import EditableTable from '../editableTable/editableTable'
import { TextField, Grid, Container, Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    width: '800px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

const handleSubmit = (e, obj, files, id, closed) => {
  e.preventDefault()
  const fileTypes = ['jpeg', 'png', 'jpg', 'JPG', 'PNG', 'JPEG', 'pdf', 'PDF']
  if (obj.queueNo.trim() === '') {
    alert('Queue number is required')
    return 'invalid'
  }
  if (!files) {
    alert('Attachment is required')
    return 'invalid'
  }
  if (files) {
    const fileType = files[0].name.split('.')
    if (!fileTypes.includes(fileType[fileType.length - 1])) {
      alert('Valid types "jpg","png", and "jpeg", "pdf"')
      return 'invalid'
    }
  }
  let formData = new FormData()
  formData.set('crfForm', JSON.stringify(obj))
  formData.append('queueUpload', files[0])
  axios({
    method: 'PUT',
    url: `${process.env.REACT_APP_API_KEY}/api/inQueue/${id}`,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
      Authorization: `Bearer ${localStorage.token}`
    },
    data: formData
  })
    .then(response => {
      if (response.data.data) {
        window.location.reload()
      }
    })
    .catch(error => {
      alert('Oops something went wrong')
      console.log(error.response)
      return 'invalid'
    })
  return null
}
export default function TransitionsModal (props) {
  const [queueNo, setQueueNo] = useState('')
  const [file, setFile] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const classes = useStyles()
  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={props.modalState}
        onClose={props.handleModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={props.modalState}>
          <div className={classes.paper}>
            <h2 id='transition-modal-title'>Attached</h2>
            <br />
            <Container>
              <form
                className={classes.root}
                noValidate
                autoComplete='off'
                onSubmit={e => {
                  const result = handleSubmit(
                    e,
                    { queueNo: queueNo, crfNo: props.crfNo },
                    file,
                    props.id,
                    props.handleModal
                  )
                  if (result === 'invalid') {
                    setDisabled(false)
                  } else {
                    setDisabled(true)
                  }
                }}
              >
                <Grid
                  container
                  direction='column'
                  justify='center'
                  alignItems='left'
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id='filled-basic'
                      label='Queue No'
                      value={queueNo}
                      onChange={e => setQueueNo(e.target.value)}
                      variant='outlined'
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id='filled-basic'
                      type='file'
                      onChange={e => {
                        setFile(e.target.files)
                      }}
                      variant='outlined'
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction='row'
                      justify='center'
                      alignItems='center'
                      spacing={0}
                    >
                      <Grid item xs={2}>
                        <Button
                          variant='contained'
                          type='submit'
                          disabled={disabled}
                        >
                          Save
                        </Button>
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          onClick={props.handleModal}
                          variant='contained'
                          color='secondary'
                          disabled={disabled}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}
